import React from 'react';
import PropTypes from 'prop-types';
import { Button, Radio } from 'semantic-ui-react';
import moment from 'moment';
import { TableForm } from 'components/Commons';
import styled from 'styled-components';

const propTypes = {
  holidays: PropTypes.arrayOf(PropTypes.any).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired
};

const HolidayModifyResult = ({ holidays, onUpdate, onDelete, handleChange }) => {
  const makeBody = () => {
    const tableData = {
      header: {
        main: [
          { data: '시작일', textAlign: 'center' },
          { data: '마지막일', textAlign: 'center' },
          { data: '기간', textAlign: 'center' },
          { data: '공휴일명', textAlign: 'center' },
          { data: '설명', textAlign: 'center' },
          { data: '활성', textAlign: 'center' },
          { data: '수정', textAlign: 'center' },
          { data: '삭제', textAlign: 'center' }
        ]
      },
      body: {
        message: '선택한 연도의 공휴일이 설정되지 않았습니다. 식권대장에 문의해주세요.',
        main: null
      }
    };

    if (holidays.length > 0) {
      tableData.body.main = holidays
        .filter((item) => !item.isDelete)
        .map((item) => {
          return {
            row: [
              {
                data: moment(item.startDate).format('YYYY-MM-DD'),
                textAlign: 'center'
              },
              {
                data: moment(item.endDate).format('YYYY-MM-DD'),
                textAlign: 'center'
              },
              {
                data: item.duration,
                textAlign: 'center'
              },
              {
                data: item.name,
                textAlign: 'center'
              },
              {
                data: item.description,
                textAlign: 'left'
              },
              {
                data: <Radio toggle checked={item.isActive} onChange={() => handleChange(item)} />,
                textAlign: 'center'
              },
              {
                data: item.updatable ? (
                  <StyledButton inverted color="black" onClick={() => onUpdate(item)}>
                    수정
                  </StyledButton>
                ) : (
                  '수정 불가'
                ),
                textAlign: 'center'
              },
              {
                data: item.deletable ? (
                  <StyledButton inverted color="black" onClick={() => onDelete(item)}>
                    삭제
                  </StyledButton>
                ) : (
                  '삭제 불가'
                ),
                textAlign: 'center'
              }
            ]
          };
        });
    }
    return tableData;
  };

  const tableData = makeBody();

  return (
    <div>
      <div className="holiday">
        <TableForm selectable="true" tabledata={tableData} />
      </div>
    </div>
  );
};

const StyledButton = styled(Button)`
  &&&& {
    width: 100px;
  }
`;

HolidayModifyResult.propTypes = propTypes;

export default HolidayModifyResult;
